import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';

// 各个页面组件
// import Home from './pages/Home/Home';
import Account from './pages/Account/Account';
import Games from './pages/Games/Games';
import Spin from './pages/Spin/Spin';
import Aidemo from './pages/Aidemo/Aidemo';
import Aidev from './pages/Aidev/Ai';
import Aivideo from './pages/Aivideo/Aivideo';
import Ai from './pages/Ai/Ai';
import NotFound from './pages/NotFound/NotFound';
import Head from './components/head/Head';
import ErrorBoundary from './components/ErrorBoundary';
import { observer } from 'mobx-react-lite';

const App = observer(() => {
  return (
    <ErrorBoundary>
      <Router>
        <div className='min-h-screen'>
          <div className="sticky top-0 z-10 bg-black">
            <Head />
          </div>
          <div className='lg:mt-0 mt-20'>
            <Routes>
              <Route path="/" element={<Navigate to="/games/" replace />} />
              <Route path="/gamecard/" element={<Account />} />
              <Route path="/games/" element={<Games />} />
              <Route path="/agent/" element={<Aidemo />} />
              <Route path="/spin/" element={<Spin />} />
              <Route path="/aigc/" element={<Ai />} />
              <Route path="/aidev/" element={<Aidev />} />
              <Route path="/aivideo/" element={<Aivideo />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>

        </div>
      </Router>
    </ErrorBoundary>
  );
});

export default App;
